import { render, staticRenderFns } from "./BaseNote.vue?vue&type=template&id=f603f134&"
import script from "./BaseNote.vue?vue&type=script&lang=ts&"
export * from "./BaseNote.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports